var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onTrigger.apply(null, arguments)}}},[_vm._t("trigger")],2),_c('transition',{attrs:{"name":"fade"}},[(_vm.opened)?_c('div',{staticClass:"transition z-10 absolute",class:[{ 
        'opacity-0': !_vm.opened,
        'top-0 left-0 mt-4': !_vm.position || _vm.position === 'top-left',
        'top-0 right-0 mt-4': _vm.position === 'top-right',
      }, _vm.floatClasses],on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("target")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }